const TOKEN_QUERY_PARAM = 'tokenOnlyUse',
  CALLBACK_URL_QUERY_PARAM = 'callbackUrl',
  LANGUAGE_QUERY_PARAM = 'language',
  TOKEN_REFRESH_BEFORE_EXPIRY_MS = 60000;

export {
  CALLBACK_URL_QUERY_PARAM,
  LANGUAGE_QUERY_PARAM,
  TOKEN_QUERY_PARAM,
  TOKEN_REFRESH_BEFORE_EXPIRY_MS,
};
